module.exports = __webpack_public_path__ + "img/checklist-icon.b2b5c51e.svg";